import type { ScheduleEvent, TaskItem, UpdatePost, User } from '../types'

const YOUTH_DEMO_USER_IDS = new Set([
  'u-leo',
  'u-lillian',
  'u-casey',
  'u-mia',
  'u-jordan',
  'u-olivia',
])

const ADULT_ALEX_CONNECTED_PROFESSIONAL_IDS = new Set(['u-jess', 'u-priya', 'u-dan', 'u-amy', 'u-sarah'])

export function adultAlexProfessionalTeam(users: User[]) {
  return users.filter(user => ADULT_ALEX_CONNECTED_PROFESSIONAL_IDS.has(user.id) && (user.role === 'support_worker' || user.role === 'allied_health'))
}

export function isYouthDemoEvent(event: ScheduleEvent) {
  if (event.id.startsWith('youth-event-')) return true
  if (YOUTH_DEMO_USER_IDS.has(event.createdByUserId)) return true
  if (event.assignees.some((assignee) => YOUTH_DEMO_USER_IDS.has(assignee.userId))) return true
  if (event.notes?.includes('Added by the child from Youth Calendar.')) return true
  return false
}

export function adultAlexEvents(events: ScheduleEvent[]) {
  return events.filter((event) => !isYouthDemoEvent(event))
}

export function isYouthDemoTask(task: TaskItem) {
  return task.id.startsWith('youth-demo-') ||
    YOUTH_DEMO_USER_IDS.has(task.assignedToUserId) ||
    YOUTH_DEMO_USER_IDS.has(task.assignedByUserId)
}

export function adultAlexTasks(tasks: TaskItem[]) {
  return tasks.filter((task) => !isYouthDemoTask(task))
}

export function isYouthDemoUpdate(update: UpdatePost, events: ScheduleEvent[]) {
  if (YOUTH_DEMO_USER_IDS.has(update.authorId)) return true
  if (!update.linkedEventId) return false
  const linkedEvent = events.find((event) => event.id === update.linkedEventId)
  return linkedEvent ? isYouthDemoEvent(linkedEvent) : update.linkedEventId.startsWith('youth-event-')
}

export function adultAlexUpdates(updates: UpdatePost[], events: ScheduleEvent[]) {
  return updates.filter((update) => !isYouthDemoUpdate(update, events))
}

